"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = require("react");
const antd_1 = require("antd");
const helpers_1 = require("../helpers");
const ReachTableFilter_1 = require("./ReachTableFilter");
class ReachTable extends React.Component {
    constructor() {
        super(...arguments);
        this.onRow = (record, index) => {
            const { onRowClick } = this.props;
            return {
                onClick: () => {
                    if (onRowClick) {
                        onRowClick(record, index);
                    }
                }
            };
        };
        this.onChange = (pagination, filters, sorter) => {
            const { collection, onCollectionUpdate } = this.props;
            collection.pagination.displayIndex = pagination.current;
            if (collection.sort) {
                collection.sort.fieldName = sorter.field;
                collection.sort.direction = sorter.order === 'ascend' ? 'ASC' : 'DESC';
            }
            if (onCollectionUpdate) {
                onCollectionUpdate(collection);
            }
        };
        this.onFilterChange = (filter) => {
            const { collection, onCollectionUpdate } = this.props;
            if (collection.filter) {
                collection.filter = filter;
            }
            if (onCollectionUpdate) {
                onCollectionUpdate(collection);
            }
        };
    }
    render() {
        const _a = this.props, { collection, loading, tableFields, filters } = _a, props = tslib_1.__rest(_a, ["collection", "loading", "tableFields", "filters"]);
        const { pagination, data, sort, filter } = collection;
        const columns = helpers_1.AndTableHelpers.toAntColumns(tableFields, sort);
        const dataSource = helpers_1.AndTableHelpers.toAntDataSource(data);
        const antdPagination = helpers_1.AndTableHelpers.toAntPagination(pagination);
        return (React.createElement(React.Fragment, null,
            filters && (React.createElement(ReachTableFilter_1.ReachTableFilter, { filters: filters, filter: filter, onFilterSelect: this.onFilterChange, bodyStyle: { padding: 0 } })),
            React.createElement(antd_1.Table, Object.assign({ onRow: this.onRow, loading: loading, columns: columns, dataSource: dataSource, pagination: antdPagination, onChange: this.onChange }, props))));
    }
}
exports.ReachTable = ReachTable;
//# sourceMappingURL=ReachTable.js.map